var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlashlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 160H32C14.375 160 0 174.375 0 192V320C0 337.625 14.375 352 32 352H384L400.125 362.75C443.25 391.5 492.75 408.375 544 413.625V98.375C492.75 103.625 443.25 120.5 400.125 149.25L384 160ZM288 288H256C238.375 288 224 273.625 224 256S238.375 224 256 224H288C305.625 224 320 238.375 320 256S305.625 288 288 288ZM608 96H576V416H608C625.625 416 640 401.625 640 384V128C640 110.375 625.625 96 608 96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashlight);
export default __webpack_public_path__ + "static/media/flashlight.8302d528a974b7cb28da0780290a9d5a.svg";
export { ForwardRef as ReactComponent };